export var TabsEnum;
(function (TabsEnum) {
    TabsEnum[TabsEnum["Einstaklingur"] = 0] = "Einstaklingur";
    TabsEnum[TabsEnum["L\u00F6ga\u00F0ili"] = 1] = "L\u00F6ga\u00F0ili";
})(TabsEnum || (TabsEnum = {}));
export var LoginMethodsEnum;
(function (LoginMethodsEnum) {
    LoginMethodsEnum[LoginMethodsEnum["ELECTRONIC_ID"] = 0] = "ELECTRONIC_ID";
    LoginMethodsEnum[LoginMethodsEnum["ESIM"] = 1] = "ESIM";
})(LoginMethodsEnum || (LoginMethodsEnum = {}));
//# sourceMappingURL=Constants.js.map